import axios from "axios";
import { del, get, post, patch,  put } from "./services_api_helper";
import * as url from "./services_url_helper";





// Get features
export const getServices = () => get(url.GET_SERVICES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewService = service => post(url.ADD_NEW_SERVICE, service, {headers: { "Content-Type": "application/json" }});



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateService = service => patch(`${url.UPDATE_SERVICE}/${service.id}`,  service);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteService = service => del(`${url.DELETE_SERVICE}/${service.id}`);







export {
  //getLoggedInUser,
  
  
};
